export class SocketServiceBase {
  invoke = <R>(method: string, ...args: any[]): Promise<R> => {
    throw new Error('invoke Method not implemented.');
  };

  close = (): void => {
    throw new Error('close Method not implemented.');
  };
}
